export function headerSearch() {
    const searchBtn = $(".header-controls .search-btn");
    const headerSearch = $(".header-search");
    const closeBtn = headerSearch.find(".close-btn");
    searchBtn.on("click", function () {
        if (window.innerWidth < 1200) {
            $(this).addClass("active");
        }
        headerSearch.addClass("active");
    });
    closeBtn.on("click", function () {
        if (window.innerWidth < 1200) {
            searchBtn.removeClass("active");
        }
        headerSearch.removeClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSearch.js